import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取预约列表
 */
export const fetchSubscribeList = async (params) => {
    const res = await GET(APIs.API_SUBSCRIBE_INDEX, { params });

    return res.data.data ?? {};
};

/**
 * 修改某个预约服务的预约日期
 */
export const fetchUpdateSubscribe = async (data) => {
    const res = await POST(APIs.API_SUBSCRIBE_UPDATESUBSCRIBE, { data });

    return res.data ?? {};
};

/**
 * 修改某个预约项目
 */
export const fetchUpdateOption = async (data) => {
    const res = await POST(APIs.API_SUBSCRIBE_UPDATEOPTION, { data });

    return res.data ?? {};
};

/**
 * 推送某个预约项目
 */
export const fetchSubscribeSend = async (id) => {
    const res = await POST(APIs.API_SUBSCRIBE_SEND, { data: { id } });

    return res.data ?? {};
};

/**
 * 通过,拒绝,取消某个预约项目
 */
export const fetchUpdateStatus = async (data) => {
    const res = await POST(APIs.API_SUBSCRIBE_UPDATESTATUS, { data });

    return res.data ?? {};
};

/**
 * 更新确认
 */
export const fetchUpdateView = async (subscribe_id) => {
    const res = await POST(APIs.API_SUBSCRIBE_UPDATEVIEW, { data: { subscribe_id } });

    return res.data ?? {};
};